<div class="modal-container">
  <div class="modal-header">
    <h2>Detalle de usuarios</h2>
    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body">
    <p>
      A continuación vas a visualizar el detalle de los usuarios que ya cumplieron
      <strong>2 meses</strong> desde que inició su servicio:
    </p>

    <table class="user-table">
      <thead>
        <tr>
          <th>Detalle</th>
          <th>Gestionar</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of data.users">
          <td>
            <span class="date">{{ user.fechaNotificacion | date:'dd/MM/yyyy' }}</span><br />
            <strong>{{ user.nombre }}</strong> ha cumplido dos meses desde que inició su
            servicio con el programa <strong>{{ user.programa }}</strong>.
            ¡Es hora de contactarl&#64;!<br />
            <span class="phone">Al número {{ user.telefono }}</span>
          </td>
          <td class="action">
            <button mat-icon-button color="primary" (click)="OnReferidosClick(user)">
              <mat-icon class="btnDownloadSession" style="padding-bottom: 5px;">arrow_forward_ios</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
